import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';
import { FALLBACK_PROJECTS } from '../data/site';

/* Loads active projects from the API once per visit and shares the result between pages
   (no repeated requests when moving between Home and Our Work).
   Falls back to the built-in list if the API is down. */
let cache = null;
let pending = null;

function load() {
  if (!pending) {
    pending = axios.get(`${API_BASE}/projects/public`, { timeout: 8000 })
      .then((r) => { if (r.data?.success && r.data.data?.length) cache = r.data.data; return cache; })
      .catch(() => { pending = null; return null; });
  }
  return pending;
}

export default function useProjects() {
  const [projects, setProjects] = useState(cache || FALLBACK_PROJECTS);
  const [loading, setLoading] = useState(!cache);
  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    load().then((data) => { if (!alive) return; if (data) setProjects(data); setLoading(false); });
    return () => { alive = false; };
  }, []);
  return { projects, loading };
}
